import { BehaviorType } from "../types";
import Behavior from "../types/Behavior";
class BlurBehavior extends Behavior {
    constructor(plasm, appName, addMetadata) {
        super(plasm, appName, addMetadata);
        this.id = BehaviorType.blur;
    }
}
export default BlurBehavior;
